import type { ProjectNames, RoleNames } from 'hooks/permission/types';

const getProjectByRole = (groups: Record<RoleNames, ProjectNames>, role?: string) => {
    return Object.entries(groups)
        .filter(([_, value]) => value.toString() === role)
        .map(([key]) => key);
};

export { getProjectByRole };
